var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal overflow-auto",
      attrs: { "select-cy": "grant-roles-modal" }
    },
    [
      _c(
        "div",
        { staticClass: "card inner-large" },
        [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "title" }, [
              _c("h2", [_vm._v("Grant Roles")]),
              _vm.isUpdating
                ? _c("div", { staticClass: "loading" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/loading-tail-spin.svg")
                      }
                    })
                  ])
                : _vm._e()
            ]),
            _c(
              "div",
              {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_c("i", { staticClass: "icn icn-x sm" })]
            )
          ]),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "choice-tables" }, [
              _vm._m(0),
              _vm._m(1),
              _c(
                "div",
                { staticClass: "left-table" },
                [
                  _vm.roles
                    ? _c("Table", {
                        attrs: {
                          items: _vm.roles,
                          attributes: _vm.rolesTableAttributes,
                          options: _vm.rolesTableOptions
                        },
                        on: { edit: _vm.grant }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "right-table" },
                [
                  _c("Table", {
                    attrs: {
                      items: _vm.grantedRoles,
                      attributes: _vm.rolesTableAttributes,
                      options: _vm.grantedTableOptions
                    },
                    on: { delete: _vm.revoke }
                  })
                ],
                1
              )
            ])
          ]),
          _vm.errorMessage
            ? _c("Alert", { attrs: { message: _vm.errorMessage } })
            : _vm._e(),
          _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "flex-grow" }),
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v("Close")]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Available Roles")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _c("h3", [_vm._v("Granted Roles")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }